import ArticleModal from '../../components/articleModal';
function showArticle(params) {
  params = {
    article: {
      title: '九商',
      content: '<p>1212025415</p>',
    },
    link: {
      linkTitle: '九商VR云',
      linkSrc: 'https://www.jsvry.com',
      linkType: '_blank',
    },
    wrapper: this.$container.get(0),
  };
  new ArticleModal(params);
}

export default {
  showArticle,
};
